import API from './api';

export const getAllUsers = async () => {
  try {
    const res = await API.get('/user');
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getUser = async (username) => {
  try {
    const res = await API.get(`/user/${username}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const addUpdate = async (update) => {
  try {
    const res = await API.post(`/user/update`, update);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deleteUpdate = async (id) => {
  try {
    const res = await API.delete(`/user/update/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const followUser = async (id) => {
  try {
    const res = await API.put(`/user/follow/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};
export const unfollowUser = async (id) => {
  try {
    const res = await API.put(`/user/unfollow/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};
